import SettingsFunds from './SettingsFunds'

export default SettingsFunds
